import { useState } from "react";

import { PlainTooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { CompanyLogo } from "app/pages/sales-intelligence/common-components/CompanyLogo/CompanyLogo";
import type { IAutoCompleteSiteItem } from "app/@types/autocomplete";
import highlightQueryWords from "app/pages/sales-intelligence/modules/company-autocomplete/utils/highlightQueryWords";

import { StyledAutocompleteItemText, StyledAutocompleteItemTextWrapper } from "../CompanyAutocompleteItem/styles";

import { StyledAutocompleteCompanyWrapper } from "./styles";

const CompanyAutocompleteSimpleItem = ({
    company,
    queryWords = [],
    onClick,
}: {
    company: IAutoCompleteSiteItem;
    queryWords?: string[];
    onClick: () => void;
}) => {
    const { companyInfo } = company;
    const companyName = companyInfo?.companyName || "";
    const [isTooltipEnabled, setIsTooltipEnabled] = useState(false);

    const setTextRef = (node: HTMLDivElement | null) => {
        if (node) {
            setIsTooltipEnabled(node.scrollWidth > node.clientWidth);
        }
    };

    return (
        <StyledAutocompleteCompanyWrapper onClick={onClick}>
            <Flex
                alignItems="center"
                overflow="hidden"
                position="relative"
            >
                <CompanyLogo src={companyInfo?.image || ""} />
                <PlainTooltip
                    tooltipContent={companyName}
                    placement="top"
                    enabled={isTooltipEnabled}
                    maxWidth={350}
                >
                    <StyledAutocompleteItemTextWrapper>
                        <StyledAutocompleteItemText ref={setTextRef}>
                            {highlightQueryWords(companyName, queryWords)}
                        </StyledAutocompleteItemText>
                    </StyledAutocompleteItemTextWrapper>
                </PlainTooltip>
            </Flex>
        </StyledAutocompleteCompanyWrapper>
    );
};

export default CompanyAutocompleteSimpleItem;
